import PostIndex from "@/domain/PostIndex";

export default class extends PostIndex {
    _childs;

    constructor(id, postCode, name, regionId, areaId, isActive) {
        super(id, postCode, name, regionId, areaId, isActive);

        this._childs = []
    }

    get childs() {
        return this._childs
    }

    set childs(value) {
        this._childs = value
    }
}